import { Text } from 'features/common/components/Text';
import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	display: flex;
	overflow: hidden;
	flex-direction: column;
	box-sizing: border-box;
	padding: 24px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		gap: 16px;
		padding: 16px;
	}
`;

export const CustomFlexContainer = styled.div`
	padding: 40px 3% 0 6%;
	display: flex;
	align-items: center;
	justify-content: space-between;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		padding: 24px 0%;
		flex-direction: column;
		gap: 20px;
	}
`;

export const Buttons = styled.div`
	display: flex;
	gap: 20px;
	align-items: center;
`;

export const Title = styled(Text)`
	font-size: 24px;
	font-weight: 600;
	margin: 0;
`;

export const TabsContainer = styled.div`
	margin-bottom: 24px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
`;

export const TabButton = styled.button<{ active?: boolean }>`
	background: none;
	border: none;
	border-bottom: 2px solid ${({ active, theme }) => (active ? theme.colors.whitePearl : 'transparent')};
	color: ${({ active, theme }) => (active ? theme.colors.whitePearl : theme.colors.grey8)};
	cursor: pointer;
	padding: 8px 16px;
	font-size: 16px;
	margin-right: 16px;
	margin-bottom: -1px;

	&:hover {
		color: ${({ theme }) => theme.colors.whitePearl};
	}
`;
